import React from "react";

const Reports = () => {
  return (
    <div>
      <h2>Relatórios</h2>
      <p>Aqui você verá seus relatórios.</p>
    </div>
  );
};

export default Reports;
